import React from "react";
import { createPortal } from "react-dom";
import { MapPin } from "lucide-react";
import styles from "./GoldCoastRating.module.css";

const GoldCoastRating = () => {
  const card = (
    <aside className={styles.dock} aria-label="Arabella Motor Inn Tweed Heads South, NSW">
      <div className={styles.resortName}>
        Arabella Motor Inn, Tweed Heads South, NSW
      </div>

      <a
        href="https://www.google.com/maps/place/Arabella+Motor+Inn/@-28.1880296,153.5379114,17z/data=!4m9!3m8!1s0x6b90ffc81fcd0c6d:0xba0e6aef62dcb581!5m2!4m1!1i2!8m2!3d-28.1880344!4d153.5404863!16s%2Fg%2F1tm88lxb?hl=en&entry=ttu&g_ep=EgoyMDI2MDkyMy4wIKXMDSoASAFQAw%3D%3D"
        className={styles.viewMap}
        target="_blank"
        rel="noopener noreferrer"
      >
        <MapPin size={18} strokeWidth={2} />
        <span>VIEW MAP</span>
      </a>
    </aside>
  );

  return createPortal(card, document.body);
};

export default GoldCoastRating;
